// @flow
import React from 'react';

const Notification = ({ text, isVisible }: { text?: string, isVisible: boolean }) =>
  isVisible ? <div className="global-notification">{text}</div> : null;

Notification.defaultProps = {
  text: '保存されました',
};

export default Notification;
